<template>
  <section class="campaigns">
    <main class="mt-3">
      <div>
        <div class="row">
          <div class="col-sm-12">
            <div class="px-4 d-inline">
              <Tabs
                :tabs="tabs"
                @change="changeTab($event)"
                :tabSelected="tabSelected"
              />
            </div>
            <section class="">
              <div class="row" v-if="hasPermissions('adminClients')">
                <div class="col-12 bg-light pb-2">
                  <div class="px-4">
                    <div
                      id="newcampaign"
                      class="top-area-opp mt-2 float-right d-none d-sm-block"
                    >
                      <button
                        class="
                          w-100
                          btn btn-sm btn-primary
                          themed-button
                          effect-btn
                        "
                        @click="addAgency"
                        type="submit"
                      >
                        <i class="icon-plus1"></i>
                        {{ $t("lang.button.addnewagency") }}
                      </button>
                    </div>
                    <div class="mt-2 float-left">
                      <FilterSystem
                        class="float-left"
                        :columns="campaignsColumns"
                        :reset="resetFilterSystem"
                        :sort="sort"
                        :dir="dir"
                        :filterSystem="filtersSystem"
                        :filterOldQuery="oldQuery"
                        :key="filterkey"
                        @callApi="filterNow($event)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div
              id="actionsSearch"
              class="pt-2 pl-4 d-flex justify-content-between bd-highlight mb-3"
              v-if="!loading && agencies.list.length > 0"
            >
              <div class="bd-highlight">
                {{ $t("lang.label.results") }}:
                <small v-if="!total" class="ml-1 text-primary"
                  >{{ $t("lang.search.calculating") }}...</small
                >
                <strong v-else>{{ total }}</strong>
              </div>
              <div>
                <Pagination
                  v-if="!loading"
                  :total="total"
                  :totalpage="agencies.list.length"
                  :model="model"
                  color="primary"
                  :limit="true"
                  @changePage="changePage"
                  :key="paginationkey"
                ></Pagination>
              </div>
              <div>.</div>
            </div>
            <div class="float-left w-100 px-4">
              <button
                class="
                  btn btn-sm btn-primary
                  themed-button
                  effect-btn
                  float-left
                  mb-2
                "
                v-if="simpleversion && !hasPermissions('isReferal')"
                @click="showAll"
              >
                {{$t('lang.button.advancedview')}}
                <i class="icon-eye"></i>
              </button>
            </div>
            <div class="px-4" style="overflow-x: scroll">
              <LoadingSpinner v-if="loading" />
              <Table
                v-if="!loading && agencies.list.length > 0 && simpleversion"
                :key="keyresult"
                :headers="simpleheader"
                :cols="simplecols"
                :data="agencies.list"
                :checkbox="false"
                :notselect="true"
                :model="model"
                @goToAgency="goToAgency"
                @sendToCrm="sendToCrm"
                @orderBy="orderBy($event)"
              >
              </Table>
              <Table
                v-if="!loading && agencies.list.length > 0 && !simpleversion"
                :key="keyresult"
                :headers="headers"
                :cols="cols"
                :data="agencies.list"
                :checkbox="false"
                :notselect="true"
                :model="model"
                @goToAgency="goToAgency"
                @sendToCrm="sendToCrm"
              >
              </Table>
              <div v-if="!loading && agencies.list.length == 0">
                <div class="text-center w-100 mt-4">
                  <div class="alert alert-warning" role="alert">
                    {{ $t("lang.label.noresults") }}
                  </div>
                </div>
                <div class="text-center w-100 mt-4">
                  <img
                    src="@/assets/images/search-oliver3.png"
                    class="rounded mx-auto d-block"
                    width="200px"
                  />
                </div>
              </div>
            </div>
            <section></section>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Table from "@/components/Common/Table.vue";
import Tabs from "@/components/Common/Tabs.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { router } from "@/_helpers";
import { statusPointMixin, billingUtilsMixin } from "@/_mixins/";
import { clientsService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import moment from "moment";
import FilterSystem from "@/components/FilterSystem.vue";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  data() {
    return {
      tabSelected: 1,
      campaignsColumns: [
        {
          name: this.$t("lang.label.companyname"),
          name_: "client",
          type: "string",
          field: "cl.name",
        },
        {
          name: this.$t("lang.column.email"),
          name_: "email",
          type: "string",
          field: "cl.email",
        },
      ],
      simpleversion: true,
      tabs: {
        1: {
          id: 1,
          name: this.$t("lang.label.all"),
        },
        2: {
          id: 2,
          name: this.$t("lang.label.createteamaccount"),
          clientStatusId: 1,
          icon: "icon-user",
        },
        3: {
          id: 3,
          name: "Onboarding",
          clientStatusId: 2,
          icon: "icon-list",
        },
        4: {
          id: 4,
          name: this.$t("lang.targets.active"),
          clientStatusId: 3,
          icon: "icon-clock",
        },
        5: {
          id: 5,
          name: this.$t("lang.appointments.active"),
          clientStatusId: 4,
          icon: "icon-play",
        },
        6: {
          id: 6,
          name: this.$t("lang.label.resting"),
          clientStatusId: 7,
          icon: "icon-refresh",
        },
        7: {
          id: 7,
          name: this.$t("lang.appointments.standby"),
          clientStatusId: 5,
          icon: "icon-pause",
        },
        8: {
          id: 8,
          name: this.$t("lang.label.pendingdeleted"),
          clientStatusId: 8,
          icon: "icon-remove",
        },
        9: {
          id: 9,
          name: this.$t("lang.label.deleted"),
          clientStatusId: 6,
          icon: "icon-remove",
        },
      },
      tabSelected: 5,
      total: 0,
      keyresult: 0,
      paginationkey: 0,
      model: {},
      loading: false,
      lastfilter: false,
      currentPage: 1,
      filterkey: 2233,
      cantPerPage: 50,
      cantPerPageOptions: [5, 10, 20, 50, 100],
      searchFilter: {},
      quickSearchFilter: "",
      selected: [],
      allSelected: false,
      campaignIds: [],
      opened: [],
      datePickerConfig: {
        format: "YYYY-MM-DD",
        useCurrent: false,
        minDate: moment().startOf("day"),
      },
      resetFilterSystem: false,
      agencies: {},
      sort: "",
      dir: "",
      simpleheader: [
        {
          label: this.$t("lang.column.status"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.actions"),
          class: "overflowhide",
          role_id: 1
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.column.name"),
          class: "overflowhide",
          orderby: true,
          field: "name",
          order: "ASC",
        },
        {
          label: this.$t("lang.column.lastname"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.column.email"),
          class: "overflowhide",
        },
        {
          label: this.$t("lang.column.phone"),
          class: "overflowhide",
        },
        // {
        //   label: this.$t("lang.appointments.meetingprice"),
        //   class: "overflowhide",
        // },
        // {
        //   label: this.$t("lang.appointments.signatureexpirationdate"),
        //   class: "overflowhide",
        // },
        {
          label: this.$t("lang.appointments.signedon"),
          class: "overflowhide",
        },
      ],
      headers: [
        {
          label: "Meeting Rate",
          class: "overflowhide",
          id:1,
        },
        {
          label: this.$t("lang.column.status"),
          class: "overflowhide",
          id:2,
        },
        {
          label: this.$t("lang.column.client"),
          class: "overflowhide",
          id:3,
        },
        {
          label: this.$t("lang.column.name"),
          class: "overflowhide",
          orderby: true,
          field: "name",
          order: "ASC",
          id:4,
        },
        {
          label: this.$t("lang.column.lastname"),
          class: "overflowhide",
          id:5,
        },
        {
          label: this.$t("lang.column.email"),
          class: "overflowhide",
          id:6,
        },
        {
          label: "Subscription",
          class: "overflowhide",
          id:7,
        },
        {
          label: this.$t("lang.column.phone"),
          class: "overflowhide",
          id:8,
        },
        {
          label: "Warmup Days",
          class: "overflowhide",
          id:9,
        },
        {
          label: this.$t("lang.appointments.signedon"),
          class: "overflowhide",
          id:10,
        },
        {
          label: this.$t("lang.column.total_meetings"),
          class: "overflowhide",
          id:19,
        },
        {
          label: this.$t("lang.column.total_meetings_this_month"),
          class: "overflowhide",
          id:20,
        },
        {
          label: this.$t("lang.column.avg_new_contact_day"),
          class: "overflowhide",
          id:21,
        },
        {
          label: this.$t("lang.column.conversion_rate"),
          class: "overflowhide",
          id:22,
        },
        {
          label: this.$t("lang.column.conversion_rate_this_month"),
          class: "overflowhide",
          id:23,
        },
        {
          label: this.$t("lang.column.avg_new_contact_day_this_month"),
          class: "overflowhide",
          id:24,
        },
        {
          label: "Spam Rate",
          class: "overflowhide",
          id:11,
        },
        {
          label: "Calendar Sync",
          class: "overflowhide",
          id:12,
        },
        {
          label: "Calendar Nylas",
          class: "overflowhide",
          id:12,
        },
        {
          label: "Landing Config",
          class: "overflowhide",
          id:13,
        },
        {
          label: this.$t("lang.label.billing"),
          class: "overflowhide",
          id:14,
        },

        {
          label: this.$t("lang.label.calendar-availabilities"),
          class: "overflowhide",
          id:15,
        },
          {
          label: this.$t("lang.label.group-missing"),
          class: "overflowhide",
          id:16,
        },
            {
          label: "Prospecting emails",
          class: "overflowhide",
          id:17,
        },
        {
          label: "Available Contacts",
          class: "overflowhide",
          id:18,
        },
      ],
      simplecols: [
        [
          {
            label: this.$t("lang.label.createteamaccount"),
            value: "client_status_id",
            value_if: 1,
            type: "condition",
          },
          {
            label: "Onboarding",
            value: "client_status_id",
            value_if: 2,
            type: "condition",
          },
          {
            label: this.$t("lang.targets.active"),
            value: "client_status_id",
            value_if: 3,
            type: "condition",
          },
          {
            label: this.$t("lang.appointments.active"),
            value: "client_status_id",
            value_if: 4,
            type: "condition",
          },
          {
            label: this.$t("lang.appointments.standby"),
            value: "client_status_id",
            value_if: 5,
            type: "condition",
          },
          {
            label: this.$t("lang.label.deleted"),
            value: "client_status_id",
            value_if: 6,
            type: "condition",
          },
          {
            label: this.$t("lang.label.resting"),
            value: "client_status_id",
            value_if: 7,
            type: "condition",
          },
          {
            label: this.$t("lang.label.pendingdeleted"),
            value: "client_status_id",
            value_if: 8,
            type: "condition",
          },
        ],
        [
          {
            label: "Send to Crm",
            value_emit: "id",
            class: "btn btn-sm btn-primary",
            type: "emit",
            emit: "sendToCrm",
            role_id: 1
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value: "name",
            class: "text-primary",
          },
        ],
        [
          {
            value: "lastname",
            class: "text-primary",
          },
        ],
        [
          {
            value: "email",
            class: "text-primary",
          },
        ],
        [
          {
            value: "phone",
            class: "text-primary",
          },
        ],
        // [
        //   {
        //     value: "meeting_price",
        //     class: "text-primary",
        //   },
        // ],
        // [
        //   {
        //     value: "signature_expiration_date",
        //     class: "text-primary",
        //     filter: "formatDate",
        //   },
        // ],
        [
          {
            value: "signed_on",
            class: "text-primary",
            filter: "formatDate",
          },
        ],
        // [
        //   {
        //     value: "creation_date",
        //     class: "text-primary",
        //   },
        // ],
      ],
      cols: [
        [
          {
            value: "meeting_rate",
            class: "text-primary",
          },
        ],
        [
          {
            value: "client_status",
            class: "text-primary",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value: "name",
            class: "text-primary",
          },
        ],
        [
          {
            value: "lastname",
            class: "text-primary",
          },
        ],
        [
          {
            value: "email",
            class: "text-primary",
          },
        ],
        [
          {
            value: "subscription_data",
            class: "text-primary",
          },
        ],
        [
          {
            value: "phone",
            class: "text-primary",
          },
        ],
        [
          {
            value: "warmup_days",
            class: "text-primary",
          },
        ],
        [
          {
            value: "signed_on",
            class: "text-primary",
            filter: "formatDate",
          },
        ],
        [
          {
            value: "total_meetings",
            class: "text-primary",
          },
        ],
        [
          {
            value: "total_meetings_this_month",
            class: "text-primary",
          },
        ],
        [
          {
            value: "total_contacts_day",
            class: "text-primary",
          },
        ],
        [
          {
            value: "meeting_rate",
            class: "text-primary",
          },
        ],
        [
          {
            value: "meeting_rate_this_month",
            type: "qty",
            class_danger: "text-danger",
            min: 0.35,
          },
        ],
        [
          {
            value: "total_contacts_day_this_month",
            type: "qty",
            class_danger: "text-danger",
            min: 300,
          },
        ],
        [
          {
            if_value: "spam_rate",
            qty_value: "spam_rate_warning_days",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "2",
                icon_true: "icon-mail text-danger",
                tooltip_true_value: "spam_rate_warning",
              },
            ],
          },
        ],
        [
          {
            if_value: "calendar_sync",
            qty_value: "calendar_sync_warning_days",
            icons: [
              {
                icon_if_value: "0",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-warning text-warning",
                tooltip_true_value: "calendar_sync_warning",
              },
            ],
          },
        ],
        [
          {
            if_value: "calendar_nylas",
            qty_value: "calendar_nylas_warning_days",
            icons: [
              {
                icon_if_value: "0",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "1",
                icon_true: "icon-warning text-warning",
                tooltip_true_value: "calendar_nylas_warning",
              },
            ],
          },
        ],
        [
          {
            if_value: "landing_config",
            qty_value: "landing_config_warning_days",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "2",
                icon_true: "icon-warning text-warning",
              },
            ],
          },
        ],
        [
          {
            if_value: "billing_config",
            qty_value: "billing_config_warning_days",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "2",
                icon_true: "icon-warning text-warning",
                tooltip_true_value: "billing_config_warning",
              },
            ],
          },
        ],
        [
          {
            if_value: "calendar_availabilities",
            qty_value: "calendar_availabilities_warning_days",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success",

              },
              {
                icon_if_value: "2",
                icon_true: "icon-warning text-warning",
                tooltip_true_value: "calendar_availabilities_warning",
              },
            ],
          },
        ],
        [
          {
            if_value: "group_missing",
            qty_value: "group_missing_warning_days",
            icons: [
              {
                icon_if_value: "1",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "2",
                icon_true: "icon-warning text-warning",
                tooltip_true_value: "group_missing_warning",
              },
            ],
          },
        ],
              [
          {
            if_value: "prospecting_emails",
            qty_value: "prospecting_emails_warning",
            icons: [
              // {
              //   icon_if_value: "0",
              //   icon_true: "icon-checkmark text-success",
              // },
              {
                icon_if_value: "2",
                icon_true: "icon-warning text-warning",
                tooltip_true_value: "prospecting_emails_warning",
              },
            ],
          },
        ],
        [
          {
            if_value: "available_contacts",
            qty_value: "available_contacts_warning_days",
            icons: [
              {
                icon_if_value: "0",
                icon_true: "icon-checkmark text-success",
              },
              {
                icon_if_value: "2",
                icon_true: "icon-warning text-warning",
                tooltip_true_value: "available_contacts_warning",
              },
            ],
          },
        ],
      ],
    };
  },

  mixins: [statusPointMixin, billingUtilsMixin],

  props: {
    filter: Object,
  },

  components: {
    LoadingSpinner,
    FilterSystem,
    Tooltip,
    Table,
    Pagination,
    Tabs,
  },
  mounted() {
    this.udpdateHeader("clients");
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.authentication.user,
      headerTab: (state) => state.header.tab,
      oldQuery: (state) => state.campaigns.oldQuery,
      filtersSystem: (state) => state.campaigns.filtersSystem,
    }),

    user() {
      return this.$store.state.authentication.user;
    },
  },

  created() {
    if (this.model.cantPerPage == undefined) {
      this.model.currentPage = 1;
      this.model.cantPerPage = this.cantPerPage;
    }

    if (!this.simpleversion) {
      this.model.getcomplete = true;
    } else {
      this.model.getcomplete = false;
    }

    this.filterByClientStatusId(5, 4);

    //Hide columsn 'calendar_availabilities', 'group_missing' to user No SuperAdmin
    if(!this.hasPermissions('superAdmin')){
      const hideHeaders = [15, 16]
      this.headers = this.headers.filter( header => !hideHeaders.includes(header.id))

      const hideColumns = ['calendar_availabilities', 'group_missing']
      this.cols = this.cols.filter(  col => !hideColumns.includes(col[0].if_value))
    }
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    changeTab(id) {
      this.tabSelected = id;
      this.filterByClientStatusId(id, this.tabs[id].clientStatusId);
    },
    hasPermissions(perm){
      return this.$store.getters['authentication/hasPermissions'](perm)
    },
    orderBy(event) {
      let order = "";
      order = `${event.field} ${event.order} `;
      this.model.order = order;
      this.searchAgencies();
      this.simpleheader.forEach((item) => {
        if (item.field == event.field) {
          if (item.order == "ASC") {
            item.order = "DESC";
          } else {
            item.order = "ASC";
          }
        }
      });
    },
    filterNow(filters) {
      this.loading = true;
      this.searchFilter = filters;
      this.model.searchFilter = this.searchFilter;
      this.searchAgencies();
      this.search();
    },
    changePage() {
      this.loading = true;
      this.searchAgencies();
    },
    sendToCrm(id){
      clientsService.sendToCrm(id)
    },
    searchAgencies() {
      clientsService.searchAgencies(this.model).then((response) => {
        response.list.forEach((item) => {
          // set domain_config_ready

          if (item.warning_campaign_creation == "1") {
            item.warning_campaign_creation == "0";
          }

          if (item.warning_campaign_launching > 0) {
            item.campaigns_launching = "2";
          } else {
            item.campaigns_launching = "1";
          }

          if (item.target_config == null) {
            item.target_config = "0";
          }

          //  showLandingConfigWarning = false;
          if (item.signed_on == null) {
            item.team_config = null;
          } else {
            if (item.workspace_domain_not_config) {
              //si tiene uno NO comprado
              item.domain_config_ready = "1";
            } else {
              if (item.workspace_domain_config) {
                //si tiene comprado
                item.domain_config_ready = "2";
              } else {
                item.domain_config_ready = "0"; //si no tiene nada
              }
            }
            /*
            if (item.workspace_user_config == 0) {
              if (item.team_config == 1) {
                item.team_config = null;
              }
            }
            if (item.billing_config == null) {
              item.billing_config = 2;
            }
            const signedOn = new Date(item.signed_on).getTime();
            const rightNow = new Date().getTime().toFixed(0);
            const days = ((rightNow - signedOn) / 1000 / 60 / 60 / 24).toFixed(
              0
            );

            if (days > 5) {
              showLandingConfigWarning = true;
            }
            */
          }

        /*  item.landing_config_ready = showLandingConfigWarning
            ? this.getConfigIsReady(item.landing_config)
            : null;*/
        });
        this.agencies = response;
        this.loading = false;
        this.keyresult++;
      });
    },
    showAll() {
      this.model.getcomplete = true;
      this.simpleversion = false;
      this.search();
    },
    getConfigIsReady(configs) {
      if (configs == null) {
        return 2;
      }
      return 1;
    },
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
    getClass(step, campaign) {
      var savedSteps;

      savedSteps = campaign.step;

      if (step == 2) {
        if (campaign.total_contacts > 0) {
          return "text-success";
        }
        return "text-secondary";
      }

      if (savedSteps == null) return "text-secondary";

      if (
        savedSteps.indexOf(step) >= 0 ||
        savedSteps.indexOf(step.toString()) >= 0
      ) {
        return "text-success";
      }
      if (savedSteps == null) return "text-secondary";

      if (
        (savedSteps.indexOf(1) >= 0 || savedSteps.indexOf("1") >= 0) &&
        (savedSteps.indexOf(3) >= 0 || savedSteps.indexOf("3") >= 0) &&
        (savedSteps.indexOf(4) >= 0 || savedSteps.indexOf("4") >= 0) &&
        (savedSteps.indexOf(5) >= 0 || savedSteps.indexOf("5") >= 0)
      ) {
        return "text-success";
      }
      return "text-secondary";
    },

    showEmptyImage() {
      return this.agencies.list.length == 0;
    },

    filterByClientStatusId(tabId, clientStatusId) {
      this.tabSelected = tabId;
      this.model.clientStatusId = clientStatusId;
      this.search();
    },

    goToAgency(client_id, client_name) {
      console.log(client_id, this.hasPermissions('isAgencyManager'), this.$store.state.authentication.user.role_id);
      if(!this.hasPermissions('isAgencyManager') || this.hasPermissions('adminAgency')){
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      }
    },
    addAgency() {
      this.changeHeaderTab({ tab: "SELECTED" });
    },
    search() {
      this.changePage();
      clientsService.searchAgenciesTotal(this.model).then((response) => {
        if (response !== undefined) {
          this.total = parseInt(response.total);
        }
      });
    },
    getPercentage(fraction, total) {
      if (total == 0) {
        return "-%";
      } else {
        var result = (fraction / total) * 100;
        result = parseFloat(result).toFixed(0);
        return result + "%";
      }
    },
  },
};
</script>
